import axios from 'axios'

interface ResponseData {
  cep: string
  logradouro: string
  complemento: string
  unidade: string
  bairro: string
  localidade: string
  uf: string
  ibge: string
  gia: string
  ddd: string
  siafi: string
}

export default class ViaCEPService {
  private client() {
    return axios.create({
      baseURL: 'https://viacep.com.br',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    })
  }

  public async search(cep: string) {
    return await this.client().get<ResponseData>(`/ws/${cep}/json`)
  }
}
